import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import InvoiceList from "./invoice_list";
import { getInvoiceByClient } from "./invoice_halper";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Select, TextField } from "@mui/material";
import { dateUsaToInd, getCurrentDate, getCurrentMonthStart } from "../frames/common";
import CashPayment from "./cash_payment";
import { getClient } from "../client/client_halper";

const cu_date = getCurrentDate();

function CompanyInvoices() {
    const [allInvoice, setAllInvoice] = useState(null);
    const [topInvoice, setTopInvoice] = useState(null);
    const [spanTime, setSpanTime] = useState('month');
    const [startTime, setStartTime] = useState("");
    const [endTime, setEndTime] = useState("");
    const [cashPayment, setCashPayment] = useState(null);
    const [accountID, setAccountID] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const params = useParams();
    const navigator = useNavigate();

    function __get_invoice_by_span(span) {
        getInvoiceByClient(params.code, span, "", "").then((res) => {
            setTopInvoice(res);
            setAllInvoice(res);
            setIsLoading(false);
        }).catch((err) => {
            setTopInvoice([]);
            setAllInvoice([]);
            setIsLoading(false);
            console.error(err);
        });
    }

    const initData = async (auth) => {
        if (!auth) return;
        await __get_invoice_by_span(spanTime);
        getClient(params.code).then((res) => {
            setAccountID(res.ac_id);
        }).catch((err) => {
            console.error(err);
        });
    }

    const handleTimeChange = (e, start) => {
        if (e.target.value === "") return;
        setSpanTime("");
        let start_ = startTime;
        let end_ = endTime;
        const n_date = dateUsaToInd(e.target.value);
        if (start) {
            start_ = n_date;
            setStartTime(n_date);
        } else {
            end_ = n_date;
            setEndTime(n_date);
        }
        if (start_ === "") { start_ = dateUsaToInd(getCurrentMonthStart()); }
        if (end_ === "") { end_ = dateUsaToInd(cu_date); }
        setIsLoading(true);
        getInvoiceByClient(params.code, "", start_, end_).then((res) => {
            setTopInvoice(res);
            setAllInvoice(res);
            setIsLoading(false);
        }).catch((err) => {
            setTopInvoice([]);
            setAllInvoice([]);
            setIsLoading(false);
            console.error(err);
        });

    }

    const handleSpanChange = (e) => {
        setSpanTime(e.target.value);
        if (e.target.value === "") return;
        setStartTime("");
        setEndTime("");
        setIsLoading(true);
        __get_invoice_by_span(e.target.value);
    }

    const handleSearch = (e) => {
        const txt = e.target.value.trim().toLowerCase();
        if (txt === "") setTopInvoice(allInvoice);
        setTopInvoice(allInvoice.filter((i) => i.bill_no.toLowerCase().includes(txt)));
    }

    const handlePaymentClose = (e) => {
        setCashPayment(null);
    }

    const handlePaymentSuccess = (e) => {
        setCashPayment(null);
    }

    return (
        <MenuFrame onSearch={handleSearch} permission="BILLING_ORG" onInit={initData}>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <CashPayment open={cashPayment !== null} onClose={handlePaymentClose} client={cashPayment} onSuccess={handlePaymentSuccess} />
            <Box sx={{ py: 2 }}>
                <Button variant="outlined" color="secondary" onClick={() => { setCashPayment(params.code); }} style={{ margin: "0px 5px", textTransform: "none" }} >Raise Consolidated Payment</Button>
                {
                    accountID === 0 ?
                        "" :
                        <Button variant="outlined" color="secondary" onClick={() => { navigator("/accounts/transaction/" + accountID) }} style={{ margin: "0px 5px", textTransform: "none" }} > Check Accounts </Button>
                }
            </Box>
            <Grid container spacing={2} sx={{ p: 2 }}>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <FormControl fullWidth>
                        <InputLabel id="time-span">Span</InputLabel>
                        <Select
                            labelId="time-span"
                            id="time-span"
                            label="Time Span"
                            value={spanTime}
                            onChange={handleSpanChange}
                        >
                            <MenuItem value={""}>None</MenuItem>
                            <MenuItem value={"day"}>Day</MenuItem>
                            <MenuItem value={"month"}>Month</MenuItem>
                            <MenuItem value={"last-month"}>Last Month</MenuItem>
                            <MenuItem value={"fy"}>Fiscal Year</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="start_date" type="date" fullWidth defaultValue={getCurrentMonthStart()} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="Start Date" onChange={(e) => { handleTimeChange(e, true) }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="end_date" type="date" fullWidth defaultValue={cu_date} slotProps={{ htmlInput: { max: cu_date, min: "2014-04-01" } }} placeholder="End Date" onChange={(e) => { handleTimeChange(e, false) }} />
                </Grid>
            </Grid>
            <InvoiceList invoice={topInvoice} />
        </MenuFrame>
    );
}

export default CompanyInvoices;
